import { server } from './env'

export const URL_ROLELOGIN = createUrl('user/login'); // 登录
export const URL_LIST = createUrl('user/list'); // 获取权限列表
export const URL_USERLIST = createUrl('user/userlist'); // 获取用户列表
export const URL_ROLELIST = createUrl('role/rolelist'); // 获取角色列表
export const URL_FUNCS = createUrl('role/funcs'); // 获取功能列表
export const URL_USER = createUrl('user/user'); // 添加用户/删除用户/修改用户
export const URL_ROLE = createUrl('role/role'); // 添加角色/删除角色/修改角色
export const URL_LOGOUT = createUrl('user/logout'); // 登出
export const URL_PASSWORD = createUrl('user/password'); // 修改密码
export const URL_AUDITLOG = createUrl('log/auditlog');
export const URL_PROFITREPORT = createUrl('report/dayTrade');
export const URL_OPENDEAL = createUrl('report/position');
export const URL_TIMEDIFF = createUrl('report/timeDiff');
export const URL_BBOOKREPORT = createUrl('report/bbook');
export const URL_CLIENT_REPORT = createUrl('report/client');

export const URL_CLOSED_TARDES_REPORT = createUrl('mt4/tradeWorth');
export const URL_SECURITY = createUrl('mt4/securities');
export const URL_SYMBOL_LIST = createUrl('mt4/symbolList');
export const URL_GROUP_LIST = createUrl('mt4/groupList');
export const URL_MT4_CLOSED_REPORT = createUrl('mt4/closedOrder');
export const URL_MT4_DEPOSIT_WITHDRAWL_REPORT = createUrl('mt4/depositWithdrawl');
export const URL_CREDIT_REPORT = createUrl('mt4/credit');
export const URL_SUMMARY_REPORT = createUrl('mt4/summary');
export const URL_SEREGATED_REPORT = createUrl('mt4/seregated');
export const URL_EQUITY_REPORT = createUrl('mt4/equity');
export const URL_PROFITLOSS_REPORT = createUrl('mt4/profitloss');
export const URL_ACCOUNT_REPORT = createUrl('mt4/account');
export const URL_EQUITY_MULTI_REPORT = createUrl('mt4/multiEquity');
export const URL_MANAGER_CHECK = createUrl('mt4/check');
export const URL_ANALYZE = createUrl('mt4/analyze');
export const URL_DOWNLOAD = createUrl('mt4/download');
export const URL_SYMBOL_PROFIT = createUrl('mt4/symbolProfit');
export const URL_PROFIT_TOP_LIST = createUrl('mt4/profitTopList');
export const URL_SEARCH = createUrl('mt4/search');
export const URL_FLOATING_PL = createUrl('mt4/floatingPL');
export const URL_OPEN_TRADES = createUrl('mt4/positionStatistics');

export const URL_HANDLE_ACCOUNT = createUrl('report/handleAccount');
export const URL_GET_MONOTOR_ACCOUNT = createUrl('report/monitorAccount');
export const URL_CHECK_TRADES = createUrl('report/checkTrades');
export const URL_MANAGER_OPERATE_LOG = createUrl('report/operateRecord');
export const URL_LOGIN_RECORD = createUrl('report/loginRecord');

export const URL_ADDORUPDATE_POSITION_CONFIG = createUrl('position/addOrUpdateConfig');
export const URL_DELETE_POSITION_CONFIG = createUrl('position/deleteConfig');
export const URL_GET_POSITION_CONFIG = createUrl('position/getConfig');

export const URL_ADDORUPDATE_LEVERAGE_CONFIG = createUrl('leverage/addOrUpdateConfig');
export const URL_DELETE_LEVERAGE_CONFIG = createUrl('leverage/deleteConfig');
export const URL_GET_LEVERAGE_CONFIG = createUrl('leverage/getConfig');

export const URL_ADDORUPDATE_DIVIDENDS_CONFIG = createUrl('dividends/addOrUpdateConfig');
export const URL_DELETE_DIVIDENDS_CONFIG = createUrl('dividends/deleteConfig');
export const URL_GET_DIVIDENDS_CONFIG = createUrl('dividends/getConfig');

export const URL_ADDORUPDATE_INTEREST_CONFIG = createUrl('interest/addOrUpdateConfig');
export const URL_DELETE_INTEREST_CONFIG = createUrl('interest/deleteConfig');
export const URL_GET_INTEREST_CONFIG = createUrl('interest/getConfig');

function createUrl (childRoute) {
    return server + childRoute;
}


// WEBPACK FOOTER //
// ./src/api/api.js